export default {
    title: 'EMPRESAS DE TRANSPORTE ADHERIDAS',
    subtitle: 'Para más información haga click en los nombres de las empresas',
    filter: 'Filter companies by:',
    all: 'All countries',
}